import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(theme => ({
  labelWrapper: {
    width: '100%',
    display: 'block',
  },
  labelInput: {
    borderRadius: '17px',
    backgroundColor: '#ffffff',
    border: '1px solid #ddd',
    boxShadow: 'none',
    padding: '15px 20px',
    width: '100%',
    boxSizing: 'border-box',
    color: '#000',
    fontSize: 12,
    lineHeight: '18px',
    fontFamily: theme.fontFamily,
    letterSpacing: '.5px',
  },
  labelInputGrey: {
    borderRadius: '17px',
    backgroundColor: '#f7f7f7',
    border: '1px solid #f7f7f7',
    boxShadow: 'none',
    padding: '15px 20px',
    width: '100%',
    boxSizing: 'border-box',
    color: '#000',
    fontSize: 12,
    lineHeight: '18px',
    fontFamily: theme.fontFamily,
    letterSpacing: '.5px',
  },

  labelParagraph: {
    marginBottom: 10,
    marginTop: 20,

    '@media (max-width: 769px)': {
      marginTop: 15,
    },
  },
  error: {
    '& textarea': {
      borderColor: '#EE2049',
    },
    '& div': {
      display: 'flex',
      fontSize: 12,
      paddingTop: 7,
      color: '#EE2049',
    },
    '& img': {
      width: 12,
      height: 12,
      marginTop: 0,
      marginRight: 5,
    },
  },
}))

const FormTextArea = ({
  greyBackground,
  inputName,
  rows,
  defaultValue,
  error,
  onChange,
  placeholder,
}) => {
  const classes = useStyles()
  return (
    <div className={`${error && classes.error}`}>
      <label className={`${classes.labelWrapper} ${error && classes.error}`}>
        <textarea
          placeholder={placeholder}
          rows={rows !== undefined ? rows : 2}
          className={greyBackground ? classes.labelInputGrey : classes.labelInput}
          name={inputName}
          onChange={onChange}
          value={defaultValue}
        />
      </label>
      {error && (
        <div>
          <img src="/themes/thrifty/assets/images/errorex.png" />
          {error.join(', ')}
        </div>
      )}
    </div>
  )
}

export default FormTextArea
